'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useForceUpdate", {
    enumerable: true,
    get: function() {
        return useForceUpdate;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function useForceUpdate() {
    return _react.useReducer((x)=>x + 1, 0)[1];
}
